/*
 * Project: forca
 * File Created: Thursday, 21st October 2021 9:58:40 am
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React, { useRef, useState, useEffect } from 'react';

import Icon from '@Components/icon';

import { RelatedContentSliderProps, RelatedContentSliderBox } from './relatedContentSlider.definition';

export const RelatedContentSlider = (props: RelatedContentSliderProps) => {
	const { title, boxes, elementMargin } = props;
	const wrapperRef = useRef(null);
	const [isDotActive, changeIsDotActive] = useState(1);

	const boxesLength = boxes.length;
	const boxWidth = 300;
	const boxGap = 20;

	useEffect(() => {
		isDotGreyedOut();
	}, []);

	const getWidthForWrapper = () => {
		// ((box width + gap) * how many boxes there is) - gap for the last element
		return ((boxWidth + boxGap) * boxesLength) - boxGap;
	};

	const onClick = (isRight) => {
		const currentPos = wrapperRef.current.scrollLeft;
		const scroll = boxWidth + boxGap;

		if (isRight) {
			wrapperRef.current.scrollLeft = currentPos + scroll;
		} else {
			wrapperRef.current.scrollLeft = currentPos - scroll;
		}

		setTimeout(() => {
			isDotGreyedOut();
		}, 300);
	};

	const isDotGreyedOut = () => {
		const wrapperWidth = wrapperRef.current.offsetWidth;
		const scrolledPos = wrapperRef.current.scrollLeft;
		const boxesWidth = boxWidth + boxGap;

		changeIsDotActive(Math.round((wrapperWidth + scrolledPos) / boxesWidth));
	};

	const renderBox = (item: RelatedContentSliderBox, index: number) => (
		<div className="RelatedContentSlider-Box" key={ index }>
			<h3 className="RelatedContentSlider-Title">{ item.title }</h3>
			<div className="RelatedContentSlider-Content" dangerouslySetInnerHTML={ { __html: item.content } } />
			{ item.link && (
				<a
					className={ `${ !item.isButton ? 'inline-button' : 'square-button button-type-1' } RelatedContentSlider-Link` }
					href={ item.link }
				>
					{ !item.isButton && <Icon icon="icon-arrow-right" /> }
					{ item.linkText }
				</a>
			) }
		</div>
	);

	return (
		<div
			className={ [
				'RelatedContentSlider',
				elementMargin ? `mb-${elementMargin}` : ''
			].join(' ') }
		>
			<div className="RelatedContentSlider-Header">
				<h3 className="RelatedContentSlider-Headline">{ title }</h3>
				<div className="RelatedContentSlider-Nav">
					<button type="button" className="inline-button" onClick={ () => onClick(false) }>
						<Icon icon="icon-arrow-left" />
					</button>
					<button type="button" className="inline-button" onClick={ () => onClick(true) }>
						<Icon icon="icon-arrow-right" />
					</button>
				</div>
			</div>

			<div className="RelatedContentSlider-Boxes-Wrapper" ref={ wrapperRef }>
				<div className="RelatedContentSlider-Boxes" style={ { width: getWidthForWrapper() } }>
					{ boxes.map((item, index) => renderBox(item, index)) }
				</div>
			</div>

			<div className="RelatedContentSlider-Dots">
				{ boxes.map((item, i) => <div className={ `RelatedContentSlider-Dot ${ isDotActive <= i ? 'RelatedContentSlider-Dot--isActive' : ''}` } key={ i } /> ) }
			</div>
		</div>
	);
};

export default RelatedContentSlider;